// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary_primary__ssYB8","submenu":"primary_submenu__68yqL","on":"primary_on__fADIh","with-sidebar":"primary_with-sidebar__q5ifT"};